package one.healthium.scanner

import androidx.compose.runtime.Composable
import one.healthium.base.launcher.PlatformLauncher

actual fun openSettings(platformLauncher: PlatformLauncher) {
}

@Composable
actual fun ScannerPermissionRequester(content: @Composable ((suspend () -> Boolean) -> Unit)) {
}